import { camelCase } from 'lodash-es'

/**
 * Recursively converts all object keys to camelCase
 * @param input - The input value to convert
 * @returns The input with all object keys converted to camelCase
 */
export const convertKeysToCamelCaseDeep = (input: any): any => {
  if (Array.isArray(input)) {
    return input.map(convertKeysToCamelCaseDeep)
  } else if (input && typeof input === 'object' && !Array.isArray(input)) {
    return Object.entries(input).reduce(
      (acc, [key, value]) => {
        acc[camelCase(key)] = convertKeysToCamelCaseDeep(value)
        return acc
      },
      {} as Record<string, any>
    )
  } else {
    return input
  }
}
